import { z } from 'zod';
import { UiPrefsSchema, LocaleSchema, type UiPrefs, type Locale } from '@shared/schemas';
import { apiFetch } from '../client';

/**
 * UI-prefs endpoints · wrap the `ui-prefs` edge function (2 endpoints).
 *
 * Per parity-ledger SM.4 / `supabase/functions/ui-prefs/index.ts`:
 *   GET   /ui-prefs/  → {uiPrefs: UiPrefs & {locale}}
 *   PATCH /ui-prefs/  → {uiPrefs: UiPrefs & {locale}}  (LWW, no per-branch conflict)
 *
 * `client.ts` strips `/api` and routes to `<supabase>/functions/v1/ui-prefs/`.
 * locale lives on `profiles.locale` server-side; prefs row in `ui_prefs`.
 */

export const UiPrefsWithLocaleSchema = UiPrefsSchema.extend({ locale: LocaleSchema });
export type UiPrefsWithLocale = z.infer<typeof UiPrefsWithLocaleSchema>;

export interface UiPrefsPatch extends Partial<UiPrefs> {
  locale?: Locale;
}

const UiPrefsResponse = z.object({ uiPrefs: UiPrefsWithLocaleSchema });

interface SignalOpts {
  signal?: AbortSignal;
}

export const uiPrefsEndpoints = {
  async get(opts: SignalOpts = {}): Promise<UiPrefsWithLocale> {
    const res = await apiFetch(UiPrefsResponse, '/api/ui-prefs', { signal: opts.signal });
    return res.uiPrefs;
  },

  async patch(body: UiPrefsPatch, opts: SignalOpts = {}): Promise<UiPrefsWithLocale> {
    const res = await apiFetch(UiPrefsResponse, '/api/ui-prefs', {
      method: 'PATCH',
      body,
      signal: opts.signal,
    });
    return res.uiPrefs;
  },
};
